/* global document, Event, HTMLInputElement, MutationObserver, requestAnimationFrame, setTimeout, window */
/**
 * Search & Filter may replace markup or sync from URL while the user is typing.
 * If the visible keyword becomes a strict prefix of what they last typed, restore
 * the longer value so mobile/desktop do not drop characters.
 *
 * @package CMNBaseTheme
 */
(function () {
  'use strict';

  var SEL =
    '.search-filter-field--type-search input[type="text"],' +
    '.search-filter-field--type-search input[type="search"]';

  /** @type {Record<string, string>} */
  var lastByFieldId = Object.create(null);

  /** Last input/change time per field id (ms); used when focus is lost briefly during AJAX. */
  /** @type {Record<string, number>} */
  var lastTypedAt = Object.create(null);

  /** ms — still treat as an active typing session after focus flicker */
  var RECENT_TYPING_MS = 2800;

  function fieldIdFromInput(el) {
    var wrap = el.closest('.search-filter-field');
    if (!wrap || !wrap.className) {
      return null;
    }
    var m = wrap.className.match(
      /(?:^|\s)search-filter-field--id-(\d+)(?:\s|$)/
    );
    return m ? m[1] : null;
  }

  /** @type {MutationObserver|null} */
  var mo = null;

  function ensureMutationObserver() {
    if (mo || typeof MutationObserver === 'undefined') {
      return;
    }
    mo = new MutationObserver(scheduleRestore);
    mo.observe(document.body, {
      subtree: true,
      childList: true,
    });
  }

  function initObserverIfKeywordFieldsPresent() {
    if (document.querySelector(SEL)) {
      ensureMutationObserver();
    }
  }

  function tryEnsureFromFocus(ev) {
    var t = ev.target;
    if (
      t instanceof HTMLInputElement &&
      (t.type === 'text' || t.type === 'search') &&
      t.closest('.search-filter-field--type-search')
    ) {
      ensureMutationObserver();
    }
  }

  function remember(ev) {
    var el = ev.target;
    if (!(el instanceof HTMLInputElement)) {
      return;
    }
    if (el.type !== 'text' && el.type !== 'search') {
      return;
    }
    if (!el.closest('.search-filter-field--type-search')) {
      return;
    }
    var id = fieldIdFromInput(el);
    if (!id) {
      return;
    }
    lastByFieldId[id] = el.value;
    lastTypedAt[id] = Date.now();
    ensureMutationObserver();
  }

  function shouldRestoreForElement(el, id) {
    if (document.activeElement === el) {
      return true;
    }
    var t = lastTypedAt[id];
    return (
      typeof t === 'number' && Date.now() - t < RECENT_TYPING_MS
    );
  }

  function restoreTruncated() {
    var inputs = document.querySelectorAll(SEL);
    var i;
    for (i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var id = fieldIdFromInput(el);
      if (!id) {
        continue;
      }
      var saved = lastByFieldId[id];
      if (saved == null || !shouldRestoreForElement(el, id)) {
        continue;
      }
      if (saved === el.value) {
        continue;
      }
      /* Empty current value means clear intent — indexOf('') is always 0, which wrongly refilled the field. */
      if (el.value.length === 0) {
        continue;
      }
      if (saved.length > el.value.length && saved.indexOf(el.value) === 0) {
        el.value = saved;
        try {
          el.dispatchEvent(new Event('input', { bubbles: true }));
        } catch {
          /* ignore */
        }
      }
    }
  }

  var scheduled = false;
  function scheduleRestore() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      restoreTruncated();
      requestAnimationFrame(function () {
        restoreTruncated();
      });
      setTimeout(function () {
        restoreTruncated();
      }, 48);
    });
  }

  window.cmnRestoreSearchFilterKeywords = restoreTruncated;

  document.addEventListener('input', remember, true);
  document.addEventListener('change', remember, true);
  document.addEventListener('focusin', tryEnsureFromFocus, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserverIfKeywordFieldsPresent);
  } else {
    initObserverIfKeywordFieldsPresent();
  }
  setTimeout(initObserverIfKeywordFieldsPresent, 0);

  document.addEventListener('visibilitychange', scheduleRestore);
})();
